export const ACCESS_TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "refreshToken";
export const IS_SIGNED_OUT_BECAUSE_INACTIVE_KEY = "isSignedOutBecauseInactive";
export const LANGUAGE_KEY = "local";
export const THERMAL_PRINTER_KEY = 'thermalPrinter'
export const THERMAL_PRINTER_PORT_KEY = 'thermalPrinterPort'